import { RouterName } from "@/enums/RouterEnum";

const {
  LOGIN,
  DOWNLOAD,
  DATA_MARKET,
  DATA_DETAIL,
  RECOMMEND,
  API_DATA_DETAIL,
  WEIXIN_PAGE,
  WEIXIN_PAY,
  WEIXIN_API_PAY,
  HOME,
  TEMPLATE_CSV,
  TEMPLATE_TEXT,
  TEMPLATE_VIDEO,
  USER_PROTOCOL,
  PRIVACY_POLICY,
  PUBLISH_DATA_WEB,
  MERCHANT_PROTOCOL,
  QUALITY_REPORT,
  STORY,
  PREVALIDATE,
  CALLBACK,
  CLIENT_CALLBACK,
  TREND,
  CLICALLBACK,
  NOT_FOUND,
} = RouterName;
export const logoutButKeep = [
  LOGIN,
  DOWNLOAD,
  RECOMMEND,
  DATA_MARKET,
  DATA_DETAIL,
  API_DATA_DETAIL,
  WEIXIN_PAGE,
  WEIXIN_PAY,
  WEIXIN_API_PAY,
  HOME,
  TEMPLATE_CSV,
  TEMPLATE_TEXT,
  TEMPLATE_VIDEO,
  USER_PROTOCOL,
  PRIVACY_POLICY,
  PUBLISH_DATA_WEB,
  MERCHANT_PROTOCOL,
  QUALITY_REPORT,
  STORY,
  PREVALIDATE,
  CALLBACK,
  CLICALLBACK,
  CLIENT_CALLBACK,
  TREND,
  NOT_FOUND,
];
export const ssrRoute = [
  RECOMMEND,
  DATA_MARKET,
  DATA_DETAIL,
  API_DATA_DETAIL,
  TREND,
  PUBLISH_DATA_WEB,
  DOWNLOAD,
  PREVALIDATE,
];
